import { useMemo, useRef } from 'react'
import { useSelector } from 'react-redux'
import { isTieredHIPlanForPlan } from 'hooks/useIsTieredHIPlan'

const arraysEqual = (a, b) => a.length === b.length && a.every((v, i) => v === b[i])

const EMPTY_RESULT = { ffOnDoctorIds: [], ffOffDoctorIds: [] }

export default () => {
  const assignedDoctors = useSelector(state => state.multiPracticeReducer.assignedDoctors.data)
  const grinPlans = useSelector(state => state.billingReducer.grinPlans)
  const prevRef = useRef(EMPTY_RESULT)

  return useMemo(() => {
    if (!assignedDoctors?.length) {
      return prevRef.current
    }

    const ffOnDoctorIds = []
    const ffOffDoctorIds = []

    for (const doctorSM of assignedDoctors) {
      const plan = grinPlans[doctorSM.grinPlanKey]
      const isTiered = isTieredHIPlanForPlan({
        grinPlanKey: doctorSM.grinPlanKey,
        grinPlanGroup: plan?.planGroup,
        withScanTracking: plan?.withScanTracking
      })

      // DoctorSearchModel.featureFlags is [String] — a flat array of flag names
      const hasObsRetentionFF = doctorSM.featureFlags?.includes('hiTieredObsRetentionCopilot')

      if (isTiered && hasObsRetentionFF) {
        ffOnDoctorIds.push(doctorSM.id)
      } else {
        ffOffDoctorIds.push(doctorSM.id)
      }
    }

    // Preserve referential identity when the computed lists haven't changed,
    // so downstream effects (eligibility-recompute) don't re-fire unnecessarily
    if (
      arraysEqual(ffOnDoctorIds, prevRef.current.ffOnDoctorIds) &&
      arraysEqual(ffOffDoctorIds, prevRef.current.ffOffDoctorIds)
    ) {
      return prevRef.current
    }

    prevRef.current = { ffOnDoctorIds, ffOffDoctorIds }
    return prevRef.current
  }, [assignedDoctors, grinPlans])
}
